module.exports = __webpack_public_path__ + "media/images/icons/outlined/book-d538bee1a4bd2eb66e4b5ccd956b2d00.svg";